import { useQuery } from "@connectrpc/connect-query";
import { searchTokens } from "@uniswap/client-search/dist/search/v1/api-searchService_connectquery";
import {
  SpamCode as SearchSpamCode
} from "@uniswap/client-search/dist/search/v1/api_pb";
import { getNativeAddress } from "uniswap/src/constants/addresses";
import { uniswapPostTransport } from "uniswap/src/data/rest/base";
import { parseProtectionInfo, parseSafetyLevel } from "uniswap/src/data/rest/utils";
import { isUniverseChainId } from "uniswap/src/features/chains/types";
import { buildCurrency, buildCurrencyInfo, getCurrencySafetyInfo } from "uniswap/src/features/dataApi/utils";
import { currencyId } from "uniswap/src/utils/currencyId";
export function useSearchTokensQuery({
  input,
  enabled = true
}) {
  return useQuery(searchTokens, input, {
    transport: uniswapPostTransport,
    enabled: !!input && enabled
  });
}
export function searchTokenToCurrencyInfo(token) {
  const { chainId, address, symbol, name, decimals, logoUrl, feeData } = token;
  if (!isUniverseChainId(chainId)) {
    return null;
  }
  const safetyLevel = parseSafetyLevel(token.safetyLevel);
  const protectionInfo = parseProtectionInfo(
    token.protectionInfo
  );
  const currency = buildCurrency({
    chainId,
    // TODO: backend currently returns 'ETH' for some native tokens, remove this check once BE fixes
    address: address === "ETH" ? getNativeAddress(chainId) : address,
    decimals,
    symbol,
    name,
    buyFeeBps: feeData?.buyFeeBps,
    sellFeeBps: feeData?.sellFeeBps
  });
  if (!currency) {
    return null;
  }
  return buildCurrencyInfo({
    currency,
    currencyId: currencyId(currency),
    logoUrl,
    safetyInfo: getCurrencySafetyInfo(safetyLevel, protectionInfo),
    isSpam: token.spamCode !== SearchSpamCode.NOT_SPAM
  });
}
